import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-icon-btn__loader"
}
const _hoisted_2 = { class: "ui-icon-btn__in" }
const _hoisted_3 = { class: "ui-icon-btn__content" }

import { PropType } from "vue";

import { HeroIcons } from "./types";

import UiLoader from "./UiLoader.vue";
import UiIcon from "./UiIcon.vue";
import UiTappable from "@/plugins/ui/components/tappable/UiTappable.vue";

type ButtonType = "button" | "reset" | "submit";
type ButtonVariant = "primary" | "secondary" | "tertiary";
type ButtonSize = "sm" | "md" | "lg";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiIconBtn',
  props: {
  type: { type: String as PropType<ButtonType>, default: "button" },
  variant: { type: String as PropType<ButtonVariant>, default: "primary" },
  size: { type: String as PropType<ButtonSize>, default: "md" },
  icon: { type: String as PropType<HeroIcons>, required: true },
  loading: Boolean,
},
  setup(__props) {



const iconSizes: Record<ButtonSize, number> = { sm: 20, md: 24, lg: 28 };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiTappable, _mergeProps(_ctx.$attrs, {
    tag: "button",
    class: ["ui-icon-btn", {
      [`ui-icon-btn--${__props.size}`]: __props.size,
      [`ui-icon-btn--${__props.variant}`]: __props.variant,
    }]
  }), {
    default: _withCtx(() => [
      (__props.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (__props.loading)
              ? (_openBlock(), _createBlock(UiLoader, { key: 0 }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(UiIcon, {
            icon: __props.icon,
            size: iconSizes[__props.size],
            type: __props.size === 'sm' ? 'solid' : 'outline'
          }, null, 8, ["icon", "size", "type"])
        ])
      ])
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})